// import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
import "bootstrap/js/dist/carousel";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/modal";
import Modal from "bootstrap/js/dist/modal";
// import 'bootstrap/js/dist/scrollspy';
import "bootstrap/js/dist/tab";
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';
import * as Sentry from "@sentry/browser";
import { isMatchingPattern } from "@sentry/core";
import htmx from "htmx.org";
import { initInventory } from "./inventory";

window.htmx = htmx;

function hasFingerprintError(event) {
  const breadcrumbs = event.breadcrumbs;
  if (!breadcrumbs?.length) {
    return false;
  }
  return breadcrumbs.some((breadcrumb) => {
    const args = breadcrumb.data?.arguments;
    if (args?.length) {
      return args.some((arg) => arg.includes("antifingerprint not defined yet"));
    }
    return false;
  });
}

function hasUnsupportedBrowser(event) {
  const headers = event?.request?.headers;
  const userAgent = headers?.["User-Agent"];
  if (!userAgent) {
    return false;
  }
  return (
    // versions of chrome from 60 to 79
    !!userAgent.match(
      /(Android [1-6].[0-9])|(AhrefsBot)|(ahrefs)|(BingPreview)|(DuckDuckGo)/,
    )
  );
}

// oxlint-disable-next-line no-unused-vars
const initSentry = () => {
  if (window.SENTRY_DSN) {
    Sentry.init({
      dsn: window.SENTRY_DSN,
      ignoreErrors: [
        "ChunkLoadError",
        /Can't find variable: setIOSParameters/,
        /\$ is not defined/,
        "ResizeObserver",
        /__gCrWeb/,
        /getMapInfo/,
        /getGraphInfo/,
        /acsbJS/,
      ],
      denyUrls: [
        /^chrome-extension:\/\//,
        /maps\.googleapis\.com/,
        /connect\.facebook\.net/,
        /ts\.js/,
        /^file:\/\/\//,
        /autocheck/,
        /hyros\.com/,
        /google-analytics\.com/,
        /spincar-static/,
        /gtag\/js/,
        /monitor\/stat/,
        /webkit-masked-url:/,
        /clickcease\.com/,
        /rlets\.com/,
        /impel\.io/,
        /tiktok\.com/,
        /safari-web-extension:/,
      ],
      beforeSend: (event) => {
        // IOS Support: ignore anything from gtm.js.
        const frames = event.exception.values?.[0].stacktrace?.frames || [];
        if (
          frames.some((frame) =>
            isMatchingPattern(frame.filename || "", /(gtm\.js)|(^chrome-extension:\/\/)/),
          )
        ) {
          return null;
        }
        if (event?.exception?.values?.length) {
          const e = event.exception.values[0];
          if (
            e.type === "UnhandledRejection" &&
            (!event.breadcrumbs?.length || hasFingerprintError(event))
          ) {
            return null;
          }
          if (hasUnsupportedBrowser(event)) {
            return null;
          }
        }
        return event;
      },
    });
  }
};

const BLOCKS = [
  { name: "map", selector: ".map" },
  { name: "location_list_page", selector: ".location-list-page" },
  { name: "popover", selector: "[data-bs-toggle='popover']" },
];
const initBlocks = () => {
  BLOCKS.forEach((block) => {
    const blockElements = document.querySelectorAll(block.selector);
    if (blockElements.length) {
      import(
        /* webpackChunkName: "blocks", webpackPrefetch: true */ `./blocks/${block.name}`
      ).then(({ render }) => {
        render(blockElements);
      });
    }
  });
};

const initPhones = () => {
  const phones = document.querySelectorAll('input[name="phone"]');
  if (phones.length) {
    import("cleave.js").then(({ default: Cleave }) => {
      document.querySelectorAll('input[name="phone"]').forEach((phoneEl) => {
        new Cleave(phoneEl, {
          delimiters: ["(", ") ", "-"],
          blocks: [0, 3, 3, 4],
          uppercase: true,
        });
      });
    });
  }
};

const initModals = () => {
  const modal = document.getElementById("static-modal");
  if (modal) {
    modal.addEventListener("show.bs.modal", (event) => {
      const content = document.querySelector(
        `#${event.relatedTarget.dataset.modalContentId}`,
      );
      const body = modal.querySelector(".modal-body");
      body.innerHTML = content.innerHTML;
    });
  }
};

/**
 *  pageYOffset can be negative on iOS
 *  Bug: iOS user scroll to top and a bit more, page bounced.
 *  We get negative pageYOffset, then page move back.
 *  And we get prevOffset (-10) > newOffset (0)
 */
const getCurrentScrollPosition = () => Math.max(0, window.pageYOffset);

const initHideOnScrolling = () => {
  let scrollOfset = 0;
  const navbar = document.querySelectorAll('.navbar-content[data-hide-on-scroll="true"]');
  if (!navbar.length) {
    return;
  }
  navbar[0].style.transition = "margin 1s";
  const isMobile = () => document.body.clientWidth < 992;
  const hideDefaultHeader = () => {
    const currentScrollPosition = getCurrentScrollPosition();
    navbar.forEach((element) => {
      const hEl = element.getBoundingClientRect().height;
      if (currentScrollPosition >= hEl) {
        element.style.marginTop = `-${hEl}px`;
      }
    });
  };

  const showDefaultHeader = () => {
    navbar.forEach((element) => {
      element.style.marginTop = 0;
    });
  };
  const handleWindowScroll = () => {
    const currentScrollPos = getCurrentScrollPosition();
    if (
      scrollOfset < currentScrollPos &&
      !document.querySelector(".navbar-collapse").classList.contains("show")
    ) {
      hideDefaultHeader();
    } else {
      showDefaultHeader();
    }
    scrollOfset = currentScrollPos;
  };
  window.addEventListener("resize", () => {
    if (isMobile()) {
      window.addEventListener("scroll", handleWindowScroll);
    } else {
      window.removeEventListener("scroll", handleWindowScroll);
    }
  });
  if (isMobile()) {
    window.addEventListener("scroll", handleWindowScroll);
  }
};

function initJSForm(form) {
  form.addEventListener("submit", function (event) {
    event.preventDefault();
    fetch("/form-submissions/", {
      method: "POST",
      body: new FormData(event.target),
    })
      .then((response) => {
        if (response.redirected) {
          return new Promise((resolve) => {
            resolve({ status: 302, url: response.url });
          });
        }
        if (response.status === 200 || response.status === 400) {
          return response
            .text()
            .then((content) => ({ status: response.status, content }));
        }
        throw Error("Server error!");
      })
      .then(
        (response) => {
          if (response.status === 302) {
            window.top.location.href = response.url;
            return;
          }
          form.outerHTML = response.content;
          if (response.status === 400) {
            initForms();
          }
        },
        () => {
          document.querySelector("#server-error").classList.remove("d-none");
        },
      );
  });
  form.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault();
      window.top.location.href = link.href;
    });
  });
}

export const initForms = () => {
  document.querySelectorAll("form").forEach((form) => {
    if (form.dataset.posthogIdentifyInitialized) {
      return;
    }
    form.addEventListener("submit", () => {
      if (!window.posthog?.identify) {
        return;
      }
      const emailInput = form.querySelector('input[type="email"]');
      const email = emailInput?.value.trim().toLowerCase();
      if (email) {
        window.posthog.identify(email, {
          email: email,
        });
      }
    });
    form.dataset.posthogIdentifyInitialized = "true";
  });
  document.querySelectorAll(".js-form").forEach(initJSForm);
  document.querySelectorAll(".form").forEach((form) => {
    form.addEventListener("submit", function (event) {
      const submitter = document.querySelector(
        `button[form="${event.currentTarget.id}"]`,
      );
      submitter.disabled = true;
      submitter.querySelector(".submit-loader").classList.remove("d-none");
      submitter.querySelector(".submit-text").classList.add("opacity-0");
    });
  });
  initPhones();
};

const initCarouselSelect = () => {
  document.querySelectorAll(".carousel-select").forEach((carouselEl) => {
    carouselEl.querySelectorAll(".carousel-select-control-prev").forEach((control) => {
      control.addEventListener("click", () => {
        const current = carouselEl.querySelector(".carousel-select-item.-active");
        if (current) {
          const next = current.previousElementSibling;
          current.classList.add("passing-when-prev");
          next.classList.add("-active");
          next.classList.toggle("coming-when-prev");
        }
      });
    });
    carouselEl.querySelectorAll(".carousel-select-control-next").forEach((control) => {
      control.addEventListener("click", () => {
        const current = carouselEl.querySelector(".carousel-select-item.-active");
        if (current) {
          const next = current.nextElementSibling;
          current.classList.add("passing-when-next");
          next.classList.add("-active");
          next.classList.toggle("coming-when-next");
        }
      });
    });
    carouselEl.querySelectorAll(".carousel-select-item").forEach((carouselItem) => {
      carouselItem.addEventListener("animationend", (event) => {
        if (event.animationName === "passing-when-next-animation") {
          event.currentTarget.classList.remove("-active");
          event.currentTarget.classList.remove("passing-when-next");
        }
        if (event.animationName === "coming-when-next-animation") {
          event.currentTarget.classList.remove("coming-when-next");
        }
        if (event.animationName === "passing-when-prev-animation") {
          event.currentTarget.classList.remove("-active");
          event.currentTarget.classList.remove("passing-when-prev");
        }
        if (event.animationName === "coming-when-prev-animation") {
          event.currentTarget.classList.remove("coming-when-prev");
        }
      });
    });
  });
};

const initTestimonialsDragScroll = () => {
  document
    .querySelectorAll(".testimonials-carousel .carousel-inner")
    .forEach((scroller) => {
      let isPointerDown = false;
      let startX = 0;
      let initialScrollLeft = 0;
      let itemStep = 0;

      const stopDrag = (event) => {
        if (!isPointerDown) {
          return;
        }
        isPointerDown = false;
        if (scroller.releasePointerCapture && event.pointerId !== undefined) {
          scroller.releasePointerCapture(event.pointerId);
        }
        if (!itemStep) {
          return;
        }
        const items = scroller.querySelectorAll(".carousel-item.-testimonials");
        const toItem =
          scroller.scrollLeft + scroller.clientWidth + itemStep / 20 >
          scroller.scrollWidth
            ? items.length - 1
            : Math.round(scroller.scrollLeft / itemStep);
        requestAnimationFrame(() => {
          scroller.scrollTo({
            left: toItem * itemStep,
            behavior: "smooth",
          });
          requestAnimationFrame(() => {
            scroller.classList.remove("is-dragging");
          });
        });
      };

      scroller.addEventListener(
        "pointerdown",
        (event) => {
          if (event.button === 0 && event.pointerType === "mouse") {
            event.preventDefault();
            isPointerDown = true;
            startX = event.clientX;
            initialScrollLeft = scroller.scrollLeft;
            const items = scroller.querySelectorAll(".carousel-item.-testimonials");
            if (items.length > 1) {
              const firstOffset = items[0].offsetLeft;
              const secondOffset = items[1].offsetLeft;
              itemStep = secondOffset - firstOffset;
            } else {
              itemStep = 0;
            }
            scroller.classList.add("is-dragging");
            if (scroller.setPointerCapture && event.pointerId !== undefined) {
              scroller.setPointerCapture(event.pointerId);
            }
          }
        },
        { passive: false },
      );

      scroller.addEventListener(
        "pointermove",
        (event) => {
          if (isPointerDown) {
            const walk = event.clientX - startX;
            scroller.scrollLeft = initialScrollLeft - walk;
            event.preventDefault();
          }
        },
        { passive: false },
      );

      scroller.addEventListener("pointerup", stopDrag);
      scroller.addEventListener("pointerleave", stopDrag);
      scroller.addEventListener("pointercancel", stopDrag);
    });
};

const initCookieAcceptance = () => {
  const banners = document.querySelectorAll(".cookie-acceptance-banner");
  if (!banners.length) {
    return;
  }

  const reject = document.getElementById("cookie-acceptance-banner-reject");
  const csrfInput = document.querySelector("[name=csrfmiddlewaretoken]");
  const csrftoken = csrfInput?.value;
  if (!csrftoken) {
    return;
  }

  document.querySelectorAll(".cookie-acceptance-banner-accept").forEach((accept) => {
    accept.addEventListener("click", () => {
      fetch("/cookie-acceptance/", {
        method: "POST",
        headers: { "X-CSRFToken": csrftoken },
        body: JSON.stringify({ solution: "accepted" }),
      }).finally(() => {
        banners.forEach((banner) => {
          banner.classList.add("d-none");
        });
        document.querySelectorAll("template.external-scripts").forEach((template) => {
          const content = template.content.cloneNode(true);
          content.querySelectorAll("script").forEach((rawScript) => {
            const realScript = document.createElement("script");
            if (rawScript.src) {
              realScript.src = rawScript.src;
            }
            if (rawScript.type) {
              realScript.type = rawScript.type;
            }
            realScript.innerHTML = rawScript.innerHTML;
            realScript.defer = rawScript.defer;
            realScript.async = rawScript.async;
            rawScript.replaceWith(realScript);
          });
          template.replaceWith(content);
        });
      });
    });
  });
  if (reject) {
    reject.addEventListener("click", () => {
      fetch("/cookie-acceptance/", {
        method: "POST",
        headers: { "X-CSRFToken": csrftoken },
        body: JSON.stringify({ solution: "rejected" }),
      }).finally(() => {
        banners.forEach((banner) => {
          banner.classList.add("d-none");
        });
      });
    });
  }
};

const dismissSiteBanner = () => {
  document.querySelectorAll(".site-announcement-banner").forEach((banner) => {
    banner.classList.add("d-none");
  });
};

const setSiteBannerDismissedCookie = (banner) => {
  if (!banner) {
    return;
  }
  const cookieName = banner.dataset.dismissCookieName;
  const cookieMaxAge = banner.dataset.dismissCookieMaxAge;
  if (!cookieName || !cookieMaxAge) {
    return;
  }
  const secureFlag = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = [
    `${cookieName}=true`,
    `Max-Age=${cookieMaxAge}`,
    "Path=/",
    `SameSite=Lax${secureFlag}`,
  ].join("; ");
};

const initSiteBanner = () => {
  if (!document.querySelector(".site-announcement-banner")) {
    return;
  }
  document
    .querySelectorAll("button.site-announcement-banner__dismiss")
    .forEach((dismissButton) => {
      dismissButton.addEventListener("click", () => {
        setSiteBannerDismissedCookie(dismissButton.closest(".site-announcement-banner"));
        dismissSiteBanner();
      });
    });
};

const initCopyButtons = () => {
  document.querySelectorAll("[data-copy-value]").forEach((button) => {
    if (button.dataset.copyInitialized) {
      return;
    }
    button.addEventListener("click", () => {
      const value = button.dataset.copyValue;
      if (!value || !navigator.clipboard || !navigator.clipboard.writeText) {
        return;
      }
      navigator.clipboard.writeText(value).then(
        () => {
          const status = button.querySelector("[data-copy-status]");
          const defaultStatus = status ? status.textContent : "";
          if (status) {
            status.textContent = "Copied";
          }
          button.classList.add("is-copied");
          window.setTimeout(() => {
            if (status) {
              status.textContent = defaultStatus;
            }
            button.classList.remove("is-copied");
          }, 1500);
        },
        () => {},
      );
    });
    button.dataset.copyInitialized = "true";
  });
};

const initInventoryMobileFilters = () => {
  const getMobileFilterBar = () => document.getElementById("inventory-mobile-filter-bar");
  const getFilterPanel = () => document.getElementById("inventory-filter-panel");
  const isMobile = () => window.matchMedia("(max-width: 991.98px)").matches;
  if (!getMobileFilterBar() || !getFilterPanel()) {
    return;
  }

  const variableTarget =
    document.querySelector(".template-inventory-page") || document.documentElement;

  const getMenuElements = () =>
    Array.from(
      new Set(
        document.querySelectorAll(
          "#navbar-container > .site-announcement-banner, #navbar-container > .navbar",
        ),
      ),
    );

  const setMenuHidden = (isHidden) => {
    if (isHidden) {
      getMenuElements().forEach((element) => {
        if (!element.classList.contains("d-none")) {
          element.dataset.inventoryFilterHiddenMenu = "true";
          element.classList.add("d-none");
        }
      });
      return;
    }

    document
      .querySelectorAll('[data-inventory-filter-hidden-menu="true"]')
      .forEach((element) => {
        element.classList.remove("d-none");
        delete element.dataset.inventoryFilterHiddenMenu;
      });
  };

  const setFilterPanelOpen = (isOpen) => {
    const filterPanel = getFilterPanel();
    const shouldOpen = isOpen && isMobile();
    if (!filterPanel) {
      return;
    }

    variableTarget.classList.toggle("inventory-filter-panel-open", shouldOpen);
    filterPanel.classList.toggle("d-none", !shouldOpen);
    setMenuHidden(shouldOpen);
    getMobileFilterBar()
      ?.querySelectorAll("[data-inventory-filter-toggle]")
      .forEach((button) => {
        button.setAttribute("aria-expanded", shouldOpen ? "true" : "false");
      });
  };

  const closeFilterPanelOnDesktop = () => {
    if (!isMobile()) {
      setFilterPanelOpen(false);
    }
  };

  document.addEventListener("click", (event) => {
    const toggleTarget = event.target.closest?.(
      "[data-inventory-filter-toggle], #inventory-mobile-filter-bar",
    );
    if (!toggleTarget) {
      return;
    }

    event.preventDefault();
    setFilterPanelOpen(!variableTarget.classList.contains("inventory-filter-panel-open"));
  });
  window.addEventListener("resize", closeFilterPanelOnDesktop);
  setFilterPanelOpen(false);
};

const initAutoCheckReport = () => {
  const iframe = document.getElementById("inventory-autocheck-report");
  if (!iframe) {
    return;
  }

  const resizeIframe = () => {
    const doc = iframe.contentDocument;
    if (!doc) {
      return;
    }

    const height = Math.max(
      doc.body?.scrollHeight || 0,
      doc.body?.offsetHeight || 0,
      doc.documentElement?.scrollHeight || 0,
      doc.documentElement?.offsetHeight || 0,
    );
    if (height) {
      iframe.style.height = `${height}px`;
    }
  };

  iframe.addEventListener("load", () => {
    resizeIframe();

    const doc = iframe.contentDocument;
    if (!doc) {
      return;
    }

    if (window.ResizeObserver) {
      new ResizeObserver(resizeIframe).observe(doc.documentElement);
    }
    if (window.MutationObserver) {
      new MutationObserver(resizeIframe).observe(doc.documentElement, {
        attributes: true,
        childList: true,
        subtree: true,
      });
    }
  });
  window.addEventListener("resize", resizeIframe);
  resizeIframe();
};

const POPUP_FORM_TIMOUT = 5000; // miliseconds

let popupFormTimeoutId;

const initPopupForm = (id) => {
  const modalEl = document.getElementById(id || "popup-form-modal");
  if (modalEl && !window.sessionStorage.getItem("popup_form_modal_opened")) {
    popupFormTimeoutId = setTimeout(() => {
      const modal = new Modal(modalEl);
      window.sessionStorage.setItem("popup_form_modal_opened", "true");
      modal.show();
    }, POPUP_FORM_TIMOUT);
  }
};

const clearPageData = () => {
  if (popupFormTimeoutId) {
    clearTimeout(popupFormTimeoutId);
  }
};

const init = () => {
  // initSentry();
  initForms();
  initBlocks();
  initModals();
  initHideOnScrolling();
  initCarouselSelect();
  initTestimonialsDragScroll();
  initCookieAcceptance();
  initSiteBanner();
  initCopyButtons();
  initInventoryMobileFilters();
  initInventory();
  initAutoCheckReport();
  initPopupForm();
};

if (document.readyState !== "loading") {
  init();
} else {
  document.addEventListener("DOMContentLoaded", init);
}

window.initPopupForm = initPopupForm;
window.clearPageData = clearPageData;
